import React, { useEffect, useState } from 'react';

import { bemCssModules } from '@cryptoboyio/mercuryo-lab/utils';
import { useTranslation } from 'react-i18next';

import { getTestId } from '@utils';

import { transactionsActions, useStore } from '@modules';
import { CryptoCurrencyEnum } from '@modules/global/types';

import LoaderLayout from '@layouts/LoaderLayout';

import NextButton from './Pieces/NextButton';
import Table from './Table';

import style from './Transactions.scss';

const cn = bemCssModules(style, 'Transactions');
const ti = getTestId('Transactions');
const LIMIT = CONST.transactions.pageSize;

export type TTransactions = {
  currency?: CryptoCurrencyEnum;
  types?: string[];
};

export const Transactions: CustomFC<TTransactions> = props => {
  const { className, currency, types = [] } = props;

  const { t } = useTranslation();
  const [{ transactions }, dispatch] = useStore();
  const { list, loaders } = transactions;
  const [isNext, setIsNext] = useState(false);
  const [isContentLoading, setIsContentLoading] = useState(true);
  const [offset, setOffset] = useState(0);

  const getTransactions = (firstRequest?: boolean) => {
    const nextOffset = firstRequest ? 0 : offset + LIMIT;
    const data = {
      total: true,
      currency,
      limit: LIMIT,
      offset: nextOffset,
      types,
    };
    dispatch(transactionsActions.getTransactions(data))
      .unwrap()
      .then(res => {
        setOffset(nextOffset);
        setIsNext(!!res.next);
      })
      .finally(() => setIsContentLoading(false));
  };

  useEffect(() => {
    if (!isContentLoading) setIsContentLoading(true);
    getTransactions(true);
  }, [currency]);

  const isLoading =
    isContentLoading || (loaders.getTransactions !== false && !Object.keys(list).length);

  return (
    <LoaderLayout isLoading={isLoading}>
      <div className={cn(null, [className])} data-testid={ti()}>
        <div className={cn('title')}>{t('transactions.h1')}</div>
        <Table list={transactions.list} />
        {isNext && (
          <NextButton
            title={t('transactions.more_transactions')}
            isLoading={loaders.getTransactions}
            onClick={getTransactions}
            data-testid={ti('button')}
          />
        )}
      </div>
    </LoaderLayout>
  );
};

export default Transactions;
